/**
 * @generated SignedSource<<595171e5ce10988926f16f6597042d38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
export type IssueStateReason = "COMPLETED" | "DUPLICATE" | "NOT_PLANNED" | "REOPENED" | "%future added value";
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type LockReason = "OFF_TOPIC" | "RESOLVED" | "SPAM" | "TOO_HEATED" | "%future added value";
export type PullRequestState = "CLOSED" | "MERGED" | "OPEN" | "%future added value";
export type UserBlockDuration = "ONE_DAY" | "ONE_MONTH" | "ONE_WEEK" | "PERMANENT" | "THREE_DAYS" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type IssueTimelineItem$data = {
  readonly __typename: string;
  readonly __id: string;
  readonly actor?: {
    readonly __typename: string;
    readonly avatarUrl: string;
    readonly displayName?: string;
    readonly id: string;
    readonly isAgent?: boolean;
    readonly isCopilot?: boolean;
    readonly login: string;
    readonly name?: string | null | undefined;
    readonly profileResourcePath: string | null | undefined;
  } | null | undefined;
  readonly assignee?: {
    readonly __typename?: string;
    readonly displayName?: string;
    readonly id?: string;
    readonly isAgent?: boolean;
    readonly isCopilot?: boolean;
    readonly login?: string;
    readonly name?: string | null | undefined;
    readonly resourcePath?: string;
  } | null | undefined;
  readonly author?: {
    readonly avatarUrl: string;
    readonly login: string;
    readonly profileUrl: string | null | undefined;
  } | null | undefined;
  readonly blockDuration?: UserBlockDuration;
  readonly blockedIssue?: {
    readonly __typename: "Issue";
    readonly id: string;
    readonly number: number;
    readonly repository: {
      readonly id: string;
      readonly isPrivate: boolean;
      readonly name: string;
      readonly owner: {
        readonly login: string;
      };
    };
    readonly stateReason: IssueStateReason | null | undefined;
    readonly titleHTML: string;
    readonly url: string;
  } | null | undefined;
  readonly blockedUser?: {
    readonly login: string;
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly blockingIssue?: {
    readonly __typename: "Issue";
    readonly id: string;
    readonly number: number;
    readonly repository: {
      readonly id: string;
      readonly isPrivate: boolean;
      readonly name: string;
      readonly owner: {
        readonly login: string;
      };
    };
    readonly stateReason: IssueStateReason | null | undefined;
    readonly titleHTML: string;
    readonly url: string;
  } | null | undefined;
  readonly closer?: {
    readonly __typename: "Commit";
    readonly abbreviatedOid: string;
    readonly repository: {
      readonly name: string;
      readonly owner: {
        readonly login: string;
      };
    };
    readonly url: string;
  } | {
    readonly __typename: "ProjectV2";
    readonly title: string;
    readonly url: string;
  } | {
    readonly __typename: "PullRequest";
    readonly number: number;
    readonly repository: {
      readonly id: string;
      readonly name: string;
      readonly owner: {
        readonly login: string;
      };
    };
    readonly url: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly closingProjectItemStatus?: string | null | undefined;
  readonly createdAt?: string;
  readonly currentTitle?: string;
  readonly databaseId?: number | null | undefined;
  readonly deletedCommentAuthor?: {
    readonly __typename: string;
    readonly login: string;
    readonly name?: string | null | undefined;
  } | null | undefined;
  readonly discussion?: {
    readonly number: number;
    readonly url: string;
  } | null | undefined;
  readonly duplicateOf?: {
    readonly __typename: "Issue";
    readonly id: string;
    readonly number: number;
    readonly repository: {
      readonly id: string;
      readonly isPrivate: boolean;
      readonly name: string;
      readonly owner: {
        readonly login: string;
      };
    };
    readonly stateReason: IssueStateReason | null | undefined;
    readonly titleHTML: string;
    readonly url: string;
  } | {
    readonly __typename: "PullRequest";
    readonly id: string;
    readonly isDraft: boolean;
    readonly isInMergeQueue: boolean;
    readonly number: number;
    readonly pullTitleHTML: string;
    readonly repository: {
      readonly id: string;
      readonly isPrivate: boolean;
      readonly name: string;
      readonly owner: {
        readonly login: string;
      };
    };
    readonly state: PullRequestState;
    readonly url: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly fromRepository?: {
    readonly nameWithOwner: string;
    readonly url: string;
  } | null | undefined;
  readonly id?: string;
  readonly intent?: {
    readonly rationale: string | null | undefined;
  } | null | undefined;
  readonly issue?: {
    readonly author: {
      readonly login: string;
    } | null | undefined;
  };
  readonly issueComment?: {
    readonly id: string;
  } | null | undefined;
  readonly issueField?: {
    readonly name?: string;
  } | null | undefined;
  readonly issueType?: {
    readonly color: IssueTypeColor;
    readonly name: string;
  } | null | undefined;
  readonly label?: {
    readonly color: string;
    readonly description: string | null | undefined;
    readonly id: string;
    readonly name: string;
    readonly nameHTML: string;
  };
  readonly lockReason?: LockReason | null | undefined;
  readonly milestone?: {
    readonly id: string;
    readonly url: string;
  } | null | undefined;
  readonly milestoneTitle?: string;
  readonly parent?: {
    readonly __typename: "Issue";
    readonly databaseId: number | null | undefined;
    readonly id: string;
    readonly number: number;
    readonly repository: {
      readonly id: string;
      readonly isPrivate: boolean;
      readonly name: string;
      readonly owner: {
        readonly login: string;
      };
    };
    readonly stateReason: IssueStateReason | null | undefined;
    readonly titleHTML: string;
    readonly url: string;
  } | null | undefined;
  readonly prevIssueType?: {
    readonly color: IssueTypeColor;
    readonly name: string;
  } | null | undefined;
  readonly previousStatus?: string;
  readonly previousTitle?: string;
  readonly project?: {
    readonly title: string;
    readonly url: string;
  } | null | undefined;
  readonly source?: {
    readonly __typename: string;
  };
  readonly stateReason?: IssueStateReason | null | undefined;
  readonly status?: string;
  readonly subIssue?: {
    readonly __typename: "Issue";
    readonly databaseId: number | null | undefined;
    readonly id: string;
    readonly number: number;
    readonly repository: {
      readonly id: string;
      readonly isPrivate: boolean;
      readonly name: string;
      readonly owner: {
        readonly login: string;
      };
    };
    readonly stateReason: IssueStateReason | null | undefined;
    readonly titleHTML: string;
    readonly url: string;
  } | null | undefined;
  readonly subject?: {
    readonly __typename: "PullRequest";
    readonly isDraft: boolean;
    readonly isInMergeQueue: boolean;
    readonly number: number;
    readonly repository: {
      readonly name: string;
      readonly owner: {
        readonly login: string;
      };
    };
    readonly state: PullRequestState;
    readonly title: string;
    readonly url: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly viewerDidAuthor?: boolean;
  readonly willCloseTarget?: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"CrossReferencedEvent" | "IssueCommentPinnedEvent" | "IssueCommentUnpinnedEvent" | "IssueComment_issueComment" | "IssueFieldAddedEvent" | "IssueFieldChangedEvent" | "IssueFieldRemovedEvent" | "MarkedAsDuplicateEvent" | "ReferencedEvent" | "UnmarkedAsDuplicateEvent">;
  readonly " $fragmentType": "IssueTimelineItem";
};
export type IssueTimelineItem$key = {
  readonly " $data"?: IssueTimelineItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTimelineItem">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "IssueTimelineItem"
};

(node as any).hash = "fd7739bf7f586afa0cab330a265002b1";

export default node;
